import { Component } from "@angular/core";
import { XOArrayField } from './xo-array-field.component';

@Component({
    selector: "xo-field-array-string",
    templateUrl: "./xo-field-array-string.component.html"
})
export class XOArrayFieldString extends XOArrayField {
}
